// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"buttons-module--arrowButton--3X9JX","crossButton":"buttons-module--crossButton--1YTKh"};